/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from "react"

interface StarIconProps {
    id: string | number
}

const StarIconComponent: React.FC<StarIconProps> = ({ id }) => {
    const [isFavorite, setIsFavorite] = useState<boolean>(
        // localStorage.getItem(`favorite_${id}`) === `true`
        false
    )

    // This runs when the page is loaded.
    useEffect(() => {

        setIsFavorite(localStorage.getItem(`favoriteGeorgianProgram_${id}`) === `true`)

    }, [])

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const toggleFavorite = () => {
        const newFavoriteState = !isFavorite
        setIsFavorite(newFavoriteState)
        localStorage.setItem(`favoriteGeorgianProgram_${id}`, String(newFavoriteState))
    }

    return <span onClick={toggleFavorite} className="text-2xl cursor-pointer">{isFavorite ? <div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 2C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22C6.27614 22 6.55229 21.8946 6.77639 21.6831L12 16.8472L17.2236 21.6831C17.4477 21.8946 17.7239 22 18 22C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H6Z" fill="black" />
    </svg></div> : <div><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 2C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22C6.27614 22 6.55229 21.8946 6.77639 21.6831L12 16.8472L17.2236 21.6831C17.4477 21.8946 17.7239 22 18 22C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H6Z" stroke="black" strokeWidth="2" fill="none" />
    </svg>
    </div>}</span>
}

export default StarIconComponent
